// 首页查询模块
import Axios from './config'

//新闻类型接口
const getnewtype = (params) => {
  return Axios({
    method: 'get',
    url: `/web/pubitem/article/articleType`,
    params: params
  })
}
//新闻列表接口
const getnewlist = (params) => {
  return Axios({
    method: 'get',
    url: `/web/article/list`,
    params: params
  })
}
//文章详情接口
const getarticle = (params) => {
  return Axios({
    method: 'get',
    url: `/web/pubitem/article/articleInfo`,
    params: params
  })
}


export{
  getnewtype,getnewlist,getarticle
}


// WEBPACK FOOTER //
// ./src/api/info.js